import { memo } from 'react'
import { styled, Typography } from '@mui/material'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { ChatBG } from '$comp/_app/components/chat/components/chat-bg'
import { t } from '$i18n'

const Container = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  background-color: ${({ theme }) => theme.palette.neutral200};
`

const TextContainer = styled('div')`
  padding: 8px 24px;
  background-color: #080d1180;
  border-radius: 20px;
`

export const RoomStartPage = memo(() => {
  return (
    <VisibilityHandler zIndex={2}>
      <Container>
        <ChatBG />

        <TextContainer>
          <Typography variant="titleRegular" color="neutral000">
            {t('chat.selectARoomToStart')}
          </Typography>
        </TextContainer>
      </Container>
    </VisibilityHandler>
  )
})
